module.exports = __webpack_public_path__ + "static/logo-tagline-45908a38038621af79bb081a651ec839.png";